import {ValueObject} from '@s-ui/domain'

export class ContactTokenUserValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.contactToken
   * */
  getContactToken() {
    return this._contactToken
  }
}
